"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = exports.Label = exports.Generic = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Generic = _styledComponents.default.div.attrs(function (_ref) {
  var margins = _ref.margins,
      margin = _ref.theme.margin;
  return {
    m: {
      t: margin[margins.t],
      r: margin[margins.r],
      b: margin[margins.b],
      l: margin[margins.l]
    }
  };
}).withConfig({
  componentId: "e8itpn-0"
})(["position:relative;transition:0.2s all linear;box-sizing:border-box;z-index:1;width:100%;", ""], function (_ref2) {
  var m = _ref2.m;
  return "\n    margin: ".concat(m.t, " ").concat(m.r, " ").concat(m.b, " ").concat(m.l, ";\n  ");
});

exports.Generic = Generic;

var Select = _styledComponents.default.select.attrs(function (_ref3) {
  var background = _ref3.background,
      mode = _ref3.theme.select.mode,
      theme = _ref3.theme,
      dark = _ref3.dark,
      color = _ref3.color;
  return {
    colorTheme: dark ? 'dark' : 'light',
    colors: {
      background: theme.color[background],
      colorPrimary: theme.color.primary,
      error: {
        color: theme.color.danger,
        hover: theme.color.danger,
        textColor: theme.color.danger
      },
      success: {
        color: theme.color.success,
        hover: theme.color.success,
        textColor: theme.color.success
      },
      light: {
        color: theme.color[color + [mode.light.color]],
        hover: theme.color[color + [mode.light.hover]],
        textColor: theme.color[color + [mode.light.textColor]]
      },
      dark: {
        color: theme.color[color + [mode.dark.color]],
        hover: theme.color[color + [mode.dark.hover]],
        textColor: theme.color[color + [mode.dark.textColor]]
      }
    }
  };
}).withConfig({
  componentId: "e8itpn-1"
})(["width:100%;appearance:none;box-sizing:border-box;background:#fff no-repeat right 0.75rem center/8px 10px;", ""], function (_ref4) {
  var colors = _ref4.colors,
      colorTheme = _ref4.colorTheme,
      focused = _ref4.focused,
      status = _ref4.status,
      _ref4$theme = _ref4.theme,
      select = _ref4$theme.select,
      typography = _ref4$theme.typography,
      color = _ref4$theme.color;
  return "\n    border: 1px solid ".concat(focused ? colors.colorPrimary : status ? colors[status].color + "!important" : colors[colorTheme].color, ";\n    color: ").concat(focused ? colors.colorPrimary : status ? colors[status].textColor + "!important" : colors[colorTheme].textColor, ";\n    background: url(\"data:image/svg+xml,%3Csvg width='25' height='16' viewBox='0 0 25 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 15.5C11.6729 15.5004 11.3495 15.431 11.0514 15.2965C10.7532 15.162 10.4872 14.9655 10.271 14.72L0.460002 3.568C0.149911 3.19845 -0.00328835 2.72224 0.0331613 2.24121C0.069611 1.76017 0.292817 1.31249 0.655052 0.993888C1.01729 0.675283 1.4898 0.511046 1.97155 0.536294C2.4533 0.561543 2.90606 0.774273 3.233 1.129L11.812 10.881C11.8355 10.9078 11.8644 10.9292 11.8968 10.9439C11.9292 10.9586 11.9644 10.9662 12 10.9662C12.0356 10.9662 12.0708 10.9586 12.1032 10.9439C12.1356 10.9292 12.1645 10.9078 12.188 10.881L20.767 1.129C20.9252 0.940422 21.1196 0.785381 21.3386 0.672986C21.5576 0.560591 21.7969 0.49311 22.0423 0.47451C22.2878 0.455911 22.5345 0.486567 22.7679 0.564678C23.0014 0.642788 23.2169 0.766777 23.4017 0.929355C23.5866 1.09193 23.737 1.28982 23.8443 1.51139C23.9516 1.73296 24.0135 1.97373 24.0264 2.21956C24.0392 2.46539 24.0028 2.71132 23.9193 2.94289C23.8358 3.17445 23.7068 3.38699 23.54 3.568L13.732 14.716C13.5155 14.9621 13.249 15.1593 12.9504 15.2944C12.6518 15.4296 12.3278 15.4997 12 15.5Z' fill='%235f6879'/%3E%3C/svg%3E%0A\") ").concat(color.white, " no-repeat right ").concat(select.padding.right, "px center/10px 12px;\n    border-radius: ").concat(select.borderRadius, "px;\n    font-family: ").concat(typography.fontFamily[0], ";\n    line-height: ").concat(select.typography.lineHeight, "px;\n    font-size: ").concat(select.typography.fontSize, "px;\n    height: ").concat(select.height, "px;\n    padding: ").concat(select.padding.top, "px ").concat(select.padding.right * 2, "px ").concat(select.padding.bottom, "px ").concat(select.padding.left, "px;\n    &:hover {\n      border-color: ").concat(focused ? colors.colorPrimary : colors[colorTheme].hover, ";\n      color: ").concat(focused ? colors.colorPrimary : colors[colorTheme].hover, ";\n    }\n  ");
});

exports.Select = Select;

var Label = _styledComponents.default.label.withConfig({
  componentId: "e8itpn-2"
})(["opacity:0;height:0px;width:0px;display:block;"]);

exports.Label = Label;